function Row({ children, className, ...rest }) {
  return (
    <div className={`columns is-multiline ${className || ''}`} {...rest}>
      {children}
    </div>
  );
}

export default Row;
